import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  paper: {
    backgroundColor: '#FFF',
    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '500px',
    maxHeight: '644px'
  },
  root: {
    padding: '0px'
  },
  subheader: {
    color: '#000000',
    fontSize: '13px',
    position: 'relative',
    lineHeight: '18px',
    paddingTop: '9px',
    fontWeight: 'bold'
  },
  listItem: {
    color: '#000000',
    fontSize: '13px',
    paddingTop: '8px',
    paddingBottom: '16px',
    fontWeight: 'lighter',
    '&:not(:last-child)': {
      borderBottom: '1px solid #E5E5E5'
    }
  },
  participantsItem: {
    borderBottom: 'none',
    fontSize: '13px',
    paddingTop: '6px',
    '&:last-child': {
      borderBottom: '1px solid #E5E5E5'
    }
  },
  participantName: {
    width: '185px',
    paddingRight: '10px'
  },
  unitTitle: {
    padding: '0px 40px 8px',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '18px',
    fontSize: '13px'
  },
  title: {
    lineHeight: '18px',
    fontSize: '15px',
    fontWeight: 'bold',
    padding: '40px 40px 12px'
  },
  unitIcon: {
    paddingRight: '10px'
  },
  closeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '10px'
  },
  cancelBtnRoot: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '70px',
    margin: 0,
    [theme.breakpoints.down('sm')]:{
      marginTop: '10px',
      minWidth: '150px'
    }
  },
  actionBtnRoot: {
    boxShadow: 'none',
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    backgroundColor: '#0e8bb4',
    color: '#FFFFFF',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    padding: '8px 15px',
    minWidth: '80px',
    '&:hover': {
      backgroundColor: '#0e8bb4',
      color: '#FFFFFF'
    },
     [theme.breakpoints.down('sm')]:{
      marginTop: '10px'
    }
  },
  closeIcon: {
    fontSize: '17px',
    color: '#000'
  },
  actionsRoot: {
    display: 'flex',
    marginTop: '16px',
    borderTop: '1px solid #E5E5E5',
    justifyContent: 'space-between',
    padding: '8px 40px',
    [theme.breakpoints.down('sm')]:{
     flexDirection: 'column',
      alignItems: 'center',
      padding: '8px 20px',
      marginTop: '10px'
    }
  },
  actionsRootOnlyView: {
    justifyContent: 'flex-end'
  },
  actionIcon: {
    cursor: 'pointer',
    fontSize: '17px'
  },
  editIcon: {
    marginRight: '7px'
  },
  actionsWrapper: {
    display: 'flex',
    marginLeft: '15px'
  }
}));
export default useStyles;
